import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "HomeStrong",
  "use": "HomeStrong-usage",
  "viewBox": "0 0 57 53",
  "content": "<symbol viewBox=\"0 0 57 53\" xmlns=\"http://www.w3.org/2000/svg\" id=\"HomeStrong\"><title>HOME Copy</title><path d=\"M.667 52.68V18.527L28.667 0l28 18.527V52.68h-56zm7-7h42V22.289l-21-13.895-21 13.895V45.68z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol